module.exports = {
	"pagination": {
		"GetDifferences": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken"
		},
		"ListBranches": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"result_key": "branches"
		},
		"ListRepositories": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"result_key": "repositories"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/codecommit-2015-04-13.paginators.json
// module id = 368
// module chunks = 0